<div class="popup-wrapper">
    <div class="popup-header color-title">
        <h2 class="popup-title">{{ display?'Welcome':'Theme Customization'}}</h2>
        <button [attr.guide]="'dashboard-popup-btn-1' + '__' + sanitizedUrl" mat-icon-button class="close-btn"
            mat-dialog-close (click)="onClose()" matTooltip="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="popup-content">
        <div *ngIf="display" class="user-details-section">
            <div class="welcome-container">
                <h3 class="welcome-title">
                    Hello {{userName}} 👋<br>
                    <span *ngIf="plan == 9 || plan == 6" class="welcome-subtext">We're happy to bring you aboard the
                        world's
                        favorite CRM!</span><br>
                    <span *ngIf="plan == 1 || plan == 17" class="welcome-subtext">We're happy to bring you aboard the
                        world's favorite dSPEEDUp!</span><br>
                    <span *ngIf="plan == 16" class="welcome-subtext">We're happy to bring you aboard the world's
                        favorite
                        Whatsapp!</span><br>
                    <span class="welcome-subtext">Let's get started!</span><br>
                    <span class="credentials-text">Your user credentials are shown below:</span>
                </h3>
            </div>


            <div class="detail-container">
                <div class="detail-row">
                    <span class="detail-label">UserName:</span>
                    <span class="detail-value">{{userList?.userName}}</span>
                    <div class="copy-btn-wrapper">
                        <span class="copy-success" [class.visible]="userNameCopied">Copied!</span>
                        <button [attr.guide]="'dashboard-popup-btn-2' + '__' + sanitizedUrl" mat-icon-button
                            (click)="copyInputUrl(userList?.userName); showCopiedFeedback('userName')"
                            [class.copied]="userNameCopied" matTooltip="Copy username">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="detail-container">
                <div class="detail-row">
                    <span class="detail-label">Password:</span>
                    <span class="detail-value">*********</span>
                    <div class="copy-btn-wrapper">
                        <span class="copy-success" [class.visible]="passwordCopied">Copied!</span>
                        <button [attr.guide]="'dashboard-popup-btn-3' + '__' + sanitizedUrl" mat-icon-button
                            (click)="copyInputUrl(userList?.password); showCopiedFeedback('password')"
                            [class.copied]="passwordCopied" matTooltip="Copy password">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="detail-container">
                <div class="detail-row">
                    <span class="detail-label">Enterprise Name:</span>
                    <span class="detail-value">{{userList?.account}}</span>
                    <div class="copy-btn-wrapper">
                        <span class="copy-success" [class.visible]="accountCopied">Copied!</span>
                        <button [attr.guide]="'dashboard-popup-btn-4' + '__' + sanitizedUrl" mat-icon-button
                            (click)="copyInputUrl(userList?.account); showCopiedFeedback('account')"
                            [class.copied]="accountCopied" matTooltip="Copy enterprise name">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- <div *ngIf="plan == 1 || plan == 17" class="detail-container">
                <div class="detail-row">
                    <span class="detail-label">Website Url:</span>
                    <span class="detail-value">{{ baseUrl}}</span>
                    <span class="copy-success" [class.visible]="baseUrlCopied">Copied!</span>
                    <div class="copy-btn-wrapper">
                        <button [attr.guide]="'dashboard-popup-btn-5' + '__' + sanitizedUrl" mat-icon-button
                            (click)="copyInputUrl(baseUrl); showCopiedFeedback('baseUrl')"
                            [class.copied]="baseUrlCopied" matTooltip="Website Url">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                </div>
            </div> -->


            <div class="next-btn-container">
                <button [attr.guide]="'dashboard-popup-btn-6' + '__' + sanitizedUrl" mat-raised-button
                    (click)="goToNext()" class="next-button primary">
                    Next
                </button>
            </div>
        </div>

        <div *ngIf="!display">
            <div class="form-container1" [formGroup]="firstFormGroup">


                <!-- <div class="form-section" *ngIf="baseUrl && baseUrl.trim().length > 0">
                    <h3 class="section-title">Website Link</h3>

                    <div class="detail-container">
                        <div class="detail-row" style="padding-bottom: 20px;">
                            <span class="detail-label">Website Url:</span> &nbsp;
                            <span class="detail-value">{{baseUrl}}</span>
                            <span class="copy-success" [class.visible]="baseUrlCopied"> &nbsp; &nbsp; &nbsp;
                                Copied!</span>
                            <button [attr.guide]="'dashboard-popup-btn-7' + '__' + sanitizedUrl" mat-icon-button
                                (click)="copyInputUrl(baseUrl); showCopiedFeedback('baseUrl')"
                                [class.copied]="baseUrlCopied" matTooltip="Website Url">
                                <mat-icon>content_copy</mat-icon>
                            </button>

                            <button [attr.guide]="'dashboard-popup-btn-8' + '__' + sanitizedUrl" mat-raised-button
                                class="primary" (click)="navigateUrl(baseUrl)" [class.copied]="baseUrl"
                                matTooltip="Website Url">
                                <span>View</span>
                            </button>
                        </div>
                    </div>
                </div> -->

                <div class="form-section">
                    <h3 class="section-title">Subscription plan</h3>
                    <div class="plan-badge-card">
                        <div class="plan-badge-icon">
                            <mat-icon>workspace_premium</mat-icon>
                        </div>
                        <div class="plan-badge-info">
                            <span class="plan-badge-label">Current Plan</span>
                            <span class="plan-badge-name">{{ planName }}</span>
                        </div>
                        <div class="plan-badge-chip">Active</div>
                    </div>
                </div>

                <div class="form-section">
                    <h3 class="section-title">Menu Styling</h3>
                    <div class="color-picker-group">
                        <div class="color-item">
                            <span class="color-label">Font Color</span>
                            <div class="color-preview">
                                <input [attr.guide]="'dashboard-popup-inp-leftmenucolor' + '__' + sanitizedUrl"
                                    type="color" formControlName="leftMenuColor" id="leftMenuColor"
                                    class="color-input" />
                                <label for="leftMenuColor" class="color-swatch"
                                    [style.background]="firstFormGroup.value.leftMenuColor"></label>
                            </div>
                        </div>
                        <div class="color-item">
                            <span class="color-label">Hover/Active</span>
                            <div class="color-preview">
                                <input [attr.guide]="'dashboard-popup-inp-leftmenuhovercolor' + '__' + sanitizedUrl"
                                    type="color" formControlName="leftMenuHoverColor" id="leftMenuHoverColor"
                                    class="color-input" />
                                <label for="leftMenuHoverColor" class="color-swatch"
                                    [style.background]="firstFormGroup.value.leftMenuHoverColor"></label>
                            </div>
                        </div>
                        <div class="color-item">
                            <span class="color-label">Background</span>
                            <div class="color-preview">
                                <input [attr.guide]="'dashboard-popup-inp-leftmenubgcolor' + '__' + sanitizedUrl"
                                    type="color" formControlName="leftMenuBgColor" id="leftMenuBgColor"
                                    class="color-input" />
                                <label for="leftMenuBgColor" class="color-swatch"
                                    [style.background]="firstFormGroup.value.leftMenuBgColor"></label>
                            </div>
                        </div>
                    </div>
                </div>

                <br>

                <div class="form-section">
                    <h3 class="section-title">Content Styling</h3>
                    <div class="color-picker-group">
                        <div class="color-item">
                            <span class="color-label">Text Color</span>
                            <div class="color-preview">
                                <input [attr.guide]="'dashboard-popup-inp-mainfontcolor' + '__' + sanitizedUrl"
                                    type="color" formControlName="mainfontcolor" id="mainfontcolor"
                                    class="color-input" />
                                <label for="mainfontcolor" class="color-swatch"
                                    [style.background]="firstFormGroup.value.mainfontcolor"></label>
                            </div>
                        </div>
                        <div class="color-item">
                            <span class="color-label">Background</span>
                            <div class="color-preview">
                                <input [attr.guide]="'dashboard-popup-inp-mainbgcolor' + '__' + sanitizedUrl"
                                    type="color" formControlName="mainBgColor" id="mainBgColor" class="color-input" />
                                <label for="mainBgColor" class="color-swatch"
                                    [style.background]="firstFormGroup.value.mainBgColor"></label>
                            </div>
                        </div>




                    </div>
                    <br>

                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" class="gridType">

                        <mat-form-field appearance="outline" fxFlex>
                            <mat-label>Grid Type</mat-label>
                            <mat-select formControlName="gridType">
                                <mat-option *ngFor="let status of leadDisplaytype" [value]="status.value">
                                    {{status.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <mat-form-field fxFlex appearance="outline">
                            <mat-label>Breadcrumb Type</mat-label>
                            <mat-select formControlName="adminBreadcrumbType">
                                <mat-option *ngFor="let item of breadcrumbtype" [value]="item.value">
                                    {{item.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>



                    </div>

                    <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                        <mat-form-field fxFlex appearance="outline">
                            <mat-label>Enable Demo Video Links</mat-label>
                            <mat-select formControlName="enableDemoVideoLinks">
                                <mat-option *ngFor="let item of booleanFieldNumber" [value]="item.value">
                                    {{item.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>



                    </div>

                    <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                        <mat-form-field appearance="outline" fxFlex>
                            <mat-label>Filter Type</mat-label>
                            <mat-select formControlName="filterType" (selectionChange)="onFilterChange($event.value)">
                                <mat-option *ngFor="let status of filterTypeList" [value]="status.value">
                                    {{status.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                        <div *ngIf="selectedFilter" class="preview-box">

                            <img [src]="selectedFilter.image" alt="{{selectedFilter.viewValue}}" width="250"
                                style="border-radius:10px">

                            <!-- <h3>{{selectedFilter.viewValue}}</h3> -->
                            <p style="margin-top: 15px; padding: 10px;font-weight: 700;">{{selectedFilter.description}}
                            </p>

                        </div>

                    </div>

                </div>

                <div class="form-section" fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="20px">
                    <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Dashboard Gap</mat-label>
                        <input [attr.guide]="'dashboard-popup-inp-dashboardgap' + '__' + sanitizedUrl" matInput
                            formControlName="dashboardGap" autocomplete="off" inputmode="numeric" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Dashboard Gap Mobile</mat-label>
                        <input [attr.guide]="'dashboard-popup-inp-dashboardgapmobile' + '__' + sanitizedUrl" matInput
                            formControlName="dashboardGapMobile" autocomplete="off" inputmode="numeric" />
                    </mat-form-field>

                </div>

                <!-- <div class="form-section">
                    <h3 class="section-title">Layout Selection</h3>
                    <div class="layout-grid" fxLayout="row wrap" fxLayoutGap="20px" style="margin-left: 20px;"
                        [ngStyle.lt-md]="'margin-left:0px;'">
                        <ng-container *ngFor="let item of adminmenutype">
                            <div class="layout-card"
                                [class.selected]="firstFormGroup.get('adminLayout')?.value === item.value"
                                (click)="setLayout(item.value)" fxFlex="0 1 calc(30% - 15px)"
                                fxFlex.lt-md="calc(50% - 10px)" fxFlex.lt-sm="100%">

                                <div class="layout-preview">
                                    <img [src]="'assets/images/admintype/' + item.viewValue + '.png'"
                                        [alt]="item.viewValue" class="layout-image">
                                </div>
                                <div class="layout-label">{{item.viewValue}}</div>
                            </div>
                        </ng-container>
                    </div>
                </div> -->
                <div class="button-container" fxLayout="row" fxLayoutAlign="end center"
                    fxLayoutAlign.lt-md="center center">
                    <button [attr.guide]="'dashboard-popup-btn-9' + '__' + sanitizedUrl" class="styled-button"
                        (click)="saveConfig()">Save</button>
                </div>

                <!-- <div class="button-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutAlign.lt-md="center center">
                    <button [attr.guide]="'dashboard-popup-btn-10' + '__' + sanitizedUrl" class="styled-button" (click)="whatsappDialogPopup()">Whatsapp Popup</button>
                </div> -->

            </div>

        </div>
    </mat-dialog-content>
</div>